import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { posthogUtil } from './@utils/posthog/posthogUtil.ts'
import { initSentry } from './@dev/sentry/sentry.ts'

import './mui.css'
import './index.css'
import '~/@dev/_style/dev.css'

initSentry()

posthogUtil()

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>,
)
